import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { NavmenuModule } from '@stantec/basin/nav-menu'
import { MainComponent } from './main.component'

@NgModule({
  declarations: [MainComponent],
  imports: [CommonModule, RouterModule, NavmenuModule],
  exports: [MainComponent],
})
export class MainModule {}
